/** Converts both operands with Number and returns their sum. */
export function add(posA: number, posB: number) {
  return Number(posA) + Number(posB);
}

/** Converts both operands with Number and returns their quotient; zero divisors retain JavaScript Infinity/NaN behavior. */
export function divide(posA: number, posB: number) {
  return Number(posA) / Number(posB);
}

/** Converts both operands with Number and subtracts the second from the first. */
export function subtract(posA: number, posB: number) {
  return Number(posA) - Number(posB);
}
